export default __webpack_public_path__ + "static/media/001-distribution-5.c340e943.png";